/**
 * 客观题答案(单选/多选/判断)
 */

import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { TopicsItem } from "../../../../../../../API/exercise";

interface StuAnswerObjProps {
    data: TopicsItem;
    stuDoFlg: string; //1提交了0未提交
}

export default function StuAnswerObj({ data, stuDoFlg }: StuAnswerObjProps) {
    return (
        // todo:详情答案怎么判断学生提没提交，老师是不是审批了？
        <div className={style.root}>
            <div className={style.body}>
                {/*学生提交了答了当前题，答案正确，显示答案给出正确图标*/}
                {stuDoFlg === "1" &&
                    data.stuFinishTopic === "1" &&
                    data.stuIsRight === "1" && (
                        <div className={style.content}>
                            <div className={style.conTitle}>我的答案</div>
                            <div className={classNames(style.conDetail)}>
                                <span
                                    className={classNames(
                                        style.conSpan,
                                        style.correct
                                    )}>
                                    {data.stuAnsText}
                                </span>
                            </div>
                        </div>
                    )}

                {/*学生提交了答了当前题，答案错误，显示答案给出错误图标*/}
                {stuDoFlg === "1" &&
                    data.stuFinishTopic === "1" &&
                    data.stuIsRight === "0" && (
                        <div className={style.content}>
                            <div className={style.conTitle}>我的答案</div>
                            <div className={classNames(style.conDetail)}>
                                <span
                                    className={classNames(
                                        style.conSpan,
                                        style.wrong
                                    )}>
                                    {data.stuAnsText}
                                </span>
                            </div>
                        </div>
                    )}

                {/*学生未提交答案状态为未作答，学生提交过如果这题没答也算未作答给出对错图标*/}
                {stuDoFlg === "0" && (
                    <div className={style.answer}>
                        我的答案
                        <span className={classNames(style.span, style.empty)}>
                            未作答
                        </span>
                    </div>
                )}
                {stuDoFlg === "1" && data.stuFinishTopic === "0" && (
                    <div className={style.answer}>
                        我的答案
                        <span
                            className={classNames(
                                style.span,
                                style.empty,
                                style.wrong
                            )}>
                            未作答
                        </span>
                    </div>
                )}

                <div className={style.score}>
                    本题得分
                    {/*没提交分数显示--,提交了分数显示数值或0*/}
                    {stuDoFlg === "0" && (
                        <span className={style.span}>
                            <em className={style.em}>--</em> 分
                        </span>
                    )}
                    {stuDoFlg === "1" && (
                        <span className={style.span}>
                            <em className={style.em}>{data.stuScore || 0}</em>{" "}
                            分
                        </span>
                    )}
                    <span className={classNames(style.span, style.totalScore)}>
                        （本题{data.score}分）
                    </span>
                </div>
            </div>

            <div className={style.footer}>
                <div className={style.footerTitle}>【正确答案】</div>
                <div
                    className={classNames(style.footerAnswer)}
                    dangerouslySetInnerHTML={{
                        __html: data.rightAnsText || "无"
                    }}
                />
            </div>
        </div>
    );
}
